import { getToken } from "@/utils/auth";
// import store from '@/store'
export default [
  {
    name: "cart",
    path: "/subscribe",
    beforeEnter: (to, from, next) => {
      if (getToken()) {
        next();
      } else {
        // store.dispatch('setToPath', '/subscribe');
        next({ path: "/register" });
      }
    },
    component: () => import("@/views/subscription/index"),
    meta: {},
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("@/views/subscription/checkout"),
    meta: {},
  },
  {
    name: "subscribe",
    path: "/subscribe",
    component: () => import("@/views/subscription/index"),
    meta: {},
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("@/views/subscription/payment"),
    meta: {},
  },
];
